export const colorsAvatar = [
  {
    bgColor: "#FF8C82",
    color: "#A10705",
  },
  {
    bgColor: "#FFC27D",
    color: "#A62100",
  },
  {
    bgColor: "#FFF394",
    color: "#AD5F00",
  },
  {
    bgColor: "#D1FF82",
    color: "#206B00",
  },
  {
    bgColor: "#89FFDD",
    color: "#007367",
  },
  {
    bgColor: "#8CD5FF",
    color: "#002E99",
  },
  {
    bgColor: "#E4C6FA",
    color: "#452981",
  },
  {
    bgColor: "#FE9AB8",
    color: "#910E38",
  },
  {
    bgColor: "#7A0000",
    color: "#FF8C82",
  },
  {
    bgColor: "#A62100",
    color: "#FFC27D",
  },
  {
    bgColor: "#AD5F00",
    color: "#FFF394",
  },
  {
    bgColor: "#206B00",
    color: "#D1FF82",
  },

  {
    bgColor: "#7A0000",
    color: "#FF8C82",
  },
  {
    bgColor: "#A62100",
    color: "#FFC27D",
  },
  {
    bgColor: "#AD5F00",
    color: "#FFF394",
  },
  {
    bgColor: "#206B00",
    color: "#D1FF82",
  },

  {
    bgColor: "#007367",
    color: "#89FFDD",
  },
  {
    bgColor: "#002E99",
    color: "#8CD5FF",
  },
  {
    bgColor: "#452981",
    color: "#E4C6FA",
  },
  {
    bgColor: "#910E38",
    color: "#FE9AB8",
  },
]